/* global Pikaday */
const DatePicker = (signinform) => {
  const fieldDateOfBirth = signinform.querySelector('.dob');
  const selectGroup = signinform.querySelector('.select-group');
  const currentDate = new Date();
  let minDay = currentDate.getDate();
  let minMonth = currentDate.getMonth() + 1;
  const minYear = currentDate.getFullYear() - 3;
  let monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  const enrollmentForm = document.querySelector('#signup-form');
  const sendToDatalayer = enrollmentForm?.getAttribute('data-send-datalayer');

  minDay = minDay < 10 ? `0${minDay}` : minDay;
  minMonth = minMonth < 10 ? `0${minMonth}` : minMonth;

  const dateWrapper = document.createElement('div');

  dateWrapper.id = 'date-select-wrapper';
  selectGroup.appendChild(dateWrapper);

  const dateFieldDay = document.createElement('select');

  dateFieldDay.classList.add('date-drop-down');
  dateFieldDay.ariaLabel = 'Dropdown for date';
  dateFieldDay.tabIndex = '0';

  const dateFieldMonth = document.createElement('select');

  dateFieldMonth.classList.add('month-drop-down');
  dateFieldMonth.ariaLabel = 'Dropdown for Month';
  dateFieldMonth.tabIndex = '0';

  const dateFieldYear = document.createElement('select');

  dateFieldYear.classList.add('year-drop-down');
  dateFieldYear.ariaLabel = 'Dropdown for year';
  dateFieldYear.tabIndex = '0';

  const dateFields = [dateFieldYear, dateFieldMonth, dateFieldDay];

  const emptyDayOption = document.createElement('option');

  emptyDayOption.value = '';
  emptyDayOption.textContent = 'Date';
  dateFieldDay.add(emptyDayOption);

  const emptyMonthOption = document.createElement('option');

  emptyMonthOption.value = '';
  emptyMonthOption.textContent = 'Month';
  dateFieldMonth.add(emptyMonthOption);

  const emptyYearOption = document.createElement('option');

  emptyYearOption.value = '';
  emptyYearOption.textContent = 'Year';
  dateFieldYear.add(emptyYearOption);

  const dayOptions = [emptyDayOption];
  const monthOptions = [emptyMonthOption];
  const yearEnd = new Date().getFullYear() + 1;
  const yearStart = yearEnd - 4;
  const yearOptions = [emptyYearOption];

  const datepicker = new Pikaday(
    {
      field: signinform.querySelector('.dob'),
      trigger: signinform.querySelector('.logo-calendar'),
      format: 'yyyy/mm/dd',
      toString(date) {
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();

        return `${year}/${month}/${day}`;
      },
      parse(dateString) {
        const parts = dateString.split('/');
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1;
        const year = parseInt(parts[2], 10);

        return new Date(year, month, day);
      },
      onSelect(date) {
        fieldDateOfBirth.value = datepicker.toString(date);
      },
      minDate: new Date(`${minYear}-${minMonth}-${minDay}`),
      maxDate: new Date(`${currentDate.getFullYear() + 1}-${minMonth}-${minDay}`),
    },
  );

  const dateChangeHandler = () => {
    const month = parseInt(dateFieldMonth.value, 10);
    const year = parseInt(dateFieldYear.value, 10);
    let maxDays = 31;

    if (month === 2) {
      const isLeapYear = ((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0);

      maxDays = isLeapYear ? 29 : 28;
    } else if ([2, 4, 6, 9, 11].indexOf(month) >= 0) {
      maxDays = 30;
    }

    const dayOptionfilter = (option, index) => {
      const opt = option;

      opt.hidden = index > maxDays;

      if (opt.hidden && opt.selected) emptyDayOption.selected = true;
    };

    dayOptions.filter(dayOptionfilter);

    let allSet = true;

    dateFields.forEach((field) => {
      const isEmpty = !field.value;

      if (isEmpty) allSet = false;
      field.classList[
        isEmpty
          ? 'add'
          : 'remove'
      ]('show-placeholder');
    });

    if (allSet) {
      fieldDateOfBirth.value = dateFields.map((field) => field.value).join('/');
      datepicker.setDate(fieldDateOfBirth.value);
    } else {
      fieldDateOfBirth.value = '';
    }
  };

  const applyDateDropDown = () => {
    if (fieldDateOfBirth.value) {
      const yearMonthDay = fieldDateOfBirth.value.split('/');

      yearOptions.forEach((option) => {
        if (option.value === yearMonthDay[0]) option.selected = true;
      });

      monthOptions[parseInt(yearMonthDay[1], 10)].selected = true;
      dayOptions[parseInt(yearMonthDay[2], 10)].selected = true;
    }
  };

  const displayEvent = (event) => {
    if (event.target.value !='' && sendToDatalayer && event.target.getAttribute('data-success') != '1' ) {
      window.dataLayer.push({
        "event": "user_registration_form_step",
        "form_name": enrollmentForm?.name,
        "form_step": event.target.getAttribute('data-step'),
        "Page URL": window.location.href.split("?")[0]
      })
    }
    event.target.setAttribute('data-success', '1');

    window.dataLayer.push({
      "event": "user_registration_form",
      "form_name": enrollmentForm?.name,
      "form_step": event.target.getAttribute('data-step'),
      "form_field": 'dob',
      "Page URL": window.location.href.split("?")[0]
    });

    applyDateDropDown(event.target);
  };

  if (window.Intl && window.Intl.DateTimeFormat) {
    try {
      const formatter = new window.Intl.DateTimeFormat([], { month: 'short', timeZone: 'UTC' });
      const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((month) => {
        const monthNumber = month < 10 ? `0${month}` : month;

        return new Date(`0000-${monthNumber}-01T00:00:00+00:00`);
      });

      monthNames = months.map((date) => formatter.format(date));
    } catch (error) {
      throw new Error(error);
    }
  }

  for (let i = 1; i <= 31; i++) {
    const newOption = document.createElement('option');

    newOption.value = (i < 10 ? '0' : '') + i;
    newOption.textContent = i;
    dayOptions.push(newOption);
    dateFieldDay.add(newOption);
  }

  for (let i = 0; i < monthNames.length; i++) {
    const newOption = document.createElement('option');

    newOption.value = (i < 9 ? '0' : '') + (i + 1);
    newOption.textContent = monthNames[i];
    monthOptions.push(newOption);
    dateFieldMonth.add(newOption);
  }

  for (let i = yearEnd; i >= yearStart; i--) {
    const newOption = document.createElement('option');

    newOption.value = i;
    newOption.textContent = i;
    yearOptions.push(newOption);
    dateFieldYear.add(newOption);
  }

  dateWrapper.appendChild(dateFieldMonth);
  dateWrapper.appendChild(dateFieldDay);
  dateWrapper.appendChild(dateFieldYear);

  fieldDateOfBirth.addEventListener('input', displayEvent);
  fieldDateOfBirth.addEventListener('change', displayEvent);
  fieldDateOfBirth.addEventListener('blur', displayEvent);

  dateFieldDay.addEventListener('change', dateChangeHandler);
  dateFieldMonth.addEventListener('change', dateChangeHandler);
  dateFieldYear.addEventListener('change', dateChangeHandler);
  dateChangeHandler();
};

const signinforms = document.querySelectorAll('.signup-form-wrapper');

signinforms.forEach((signinform) => {
  DatePicker(signinform);
});
